<template>
	<vs-chip class="ag-grid-cell-chip" color="success">
		<vs-icon :title="chipText(params.value)" style="font-size: 1.5rem" :icon="getIcon(params.value)"> </vs-icon>
	</vs-chip>
</template>

<script>
export default {
	name: "CellRendererProfile",
	computed: {
		chipText() {
			return (value) => {
				if (value === "car") return this.$t("Routing.Car");
				else if (value === "walk") return this.$t("Routing.Walking");
				else if (value === "bicycle") return this.$t("Routing.Bicycle");
				else if (value === "motorcycle") return this.$t("Routing.Motorcycle");
				else if (value === "truck") return this.$t("Routing.Truck");
				else if (value === "scooter") return this.$t("Routing.Scooter");
				else if (value === "bus") return this.$t("Routing.Bus");
				else if (value === "unknown") return this.$t("NotSpecified");
				else return "";
			};
		},
		getIcon() {
			return function (param) {
				let icon = "";
				switch (param) {
					case "car":
						icon = "local_taxi";
						break;
					case "walk":
						icon = "directions_walk";
						break;
					case "bicycle":
						icon = "directions_bike";
						break;
					case "motorcycle":
						icon = "two_wheeler";
						break;
					case "truck":
						icon = "local_shipping";
						break;
					case "scooter":
						icon = "rv_hookup";
						break;
					case "bus":
						icon = "directions_bus";
						break;
					case "unknown":
						icon = "bus_alert";
						break;
				}
				return icon;
			};
		},
	},
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
	&.vs-chip-success {
		background: rgba(var(--vs-success), 0.15);
		color: rgba(var(--vs-success), 1) !important;
		font-weight: 500;
	}
	&.vs-chip-warning {
		background: rgba(var(--vs-warning), 0.15);
		color: rgba(var(--vs-warning), 1) !important;
		font-weight: 500;
	}
	&.vs-chip-danger {
		background: rgba(var(--vs-danger), 0.15);
		color: rgba(var(--vs-danger), 1) !important;
		font-weight: 500;
	}
}
</style>
